import React, { useContext, useRef } from 'react';
import { Form, Heading, StepperContext } from '@digitools/honest-ui';
import useTranslate from 'src/hooks/useTranslate';
import useExperience from 'src/hooks/useExperience';
import { Experience } from 'src/types/Experience';
import ConditionCircumstance from './ConditionCircumstance';
import AboutAccommodationText from '../../constants/AboutAccommodationText';
import StepperButtons from '../../components/StepperButtons';
import AddAccommodationRequest from './AddAccommodationRequest';
import useAsDataContext from '../../hooks/useAsDataContext';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import useTealium from 'src/hooks/useTealium';
import { CustomEmployeeText } from 'src/utils/CustomExperienceText';
const AboutAccommodation = () => {
    const { t } = useTranslate();
    const { experience } = useExperience();
    const { trackEvent } = useTealium();
    const { requestCount, conditionData, setConditionData, accommodationRequestDataArray, setAccommodationRequestDataArray } = useAsDataContext();
    const stepper = useContext(StepperContext);
    const ref = useRef();
    const pageTitle = CustomEmployeeText(experience === Experience.EMPLOYEE ? t(AboutAccommodationText.aboutAccommodationEE) : t(AboutAccommodationText.aboutAccommodationER));
    const submit = (values) => {
        const requestValues = values.accommodationRequestValues ?? {};
        let accdataArr = [];
        for (let i = 1; i <= requestCount; i++) {
            let updatedAccommodationRequestData1 = {
                rtwWithoutAccomodationDate: requestValues[`rtwWithoutAccomodationDate${i}`],
                requestReceivedDate: requestValues[`requestReceivedDate${i}`],
                status: requestValues[`status${i}`],
                closedDate: requestValues[`closedDate${i}`],
                statusReasonCode: requestValues[`statusReasonCode${i}`],
                assistanceRequired: requestValues[`assistanceRequired${i}`],
                providedAccomodationTypeCode: requestValues[`providedAccomodationTypeCode${i}`],
                providedDetailsText: requestValues[`providedDetailsText${i}`],
                actualBeginDate: requestValues[`actualBeginDate${i}`],
                restrictionsAndLimits: requestValues[`restrictionsAndLimits${i}`],
                suppRestrictionsAndLimitations: requestValues[`suppRestrictionsAndLimitations${i}`],
                interactiveBeginDate: requestValues[`interactiveBeginDate${i}`],
                initialMeetingDate: requestValues[`initialMeetingDate${i}`],
                determinationInfoReceivedDate: requestValues[`determinationInfoReceivedDate${i}`],
                determinationDate: requestValues[`determinationDate${i}`],
                priorCarrier: requestValues[`priorCarrier${i}`],
                requestedAccommodationCost: requestValues[`requestedAccommodationCost${i}`],
                providedCostAmount: requestValues[`providedCostAmount${i}`],
                actualEndDate: requestValues[`actualEndDate${i}`],
                requestedAccommodationType: requestValues[`accomodationRequestType${i}`],
                requestedAccommodationDetail: requestValues[`isTimeawayfromWork${i}`],
                requestedPeriodType: requestValues[`temporaryorPermanentRequest${i}`],
                requestedStartDate: requestValues[`desiredStartDate${i}`],
                existingAccommodation: requestValues[`isAlreadyReported${i}`],
                accommodationWorkOrHome: requestValues[`workStatus${i}`],
                anticipatedEndDate: requestValues[`anticipatedEndDate${i}`],
                id: i
            };
            const updatedAccommodationRequestData = { ...accommodationRequestDataArray, ...updatedAccommodationRequestData1 };
            accdataArr.push(updatedAccommodationRequestData);
        }
        setAccommodationRequestDataArray(accdataArr);
        const updatedConditionData = { ...conditionData, ...values.conditionData };
        setConditionData(updatedConditionData);
        trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.SELF_SERVICE,
            event_name: 'save and continue',
            event_type: TEALIUM_EVENT.EVENT_TYPE.ACCOMMODATION,
            event_version: pageTitle,
            event_status: 'step 3',
        });
        /* Send to the next step */
        stepper.next();
        window.scrollTo(0, 0);
    };
    return (<div ref={ref} data-testid='about-accommodation'>
      <Heading as='h2' visualLevel='h3' weight='bold' color='secondary' className='hui-mb-xl'>
        {pageTitle}
      </Heading>
      <Form onSubmit={submit}>
        <ConditionCircumstance />
        <AddAccommodationRequest />
        <StepperButtons suppressNext analyticsPageName='about accommodation'/>
      </Form>
    </div>);
};
export default React.memo(AboutAccommodation);
